import React from 'react';
import { Text, View } from "../../Components/Themed"
import type { BracketCompetitionProps } from "../../types"
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';

type BracketRowProps = {
    market_type:'FOR_MONEY'|'FREE',
    bracket_competition:BracketCompetitionProps,
    width:number
}

const BracketRow = ({ market_type, bracket_competition, width }:BracketRowProps) => {
    const Colors = useColors();
    const cl = market_type == 'FOR_MONEY' ? '$' : 'E'

    return (
        <View>
            <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light, flexWrap:'wrap' }}>
                <Icons.BracketIcon size={22} color={Colors.text.h1} />
                <View transparent style={{ borderRadius:0, padding:0, borderLeftWidth:1, borderColor:Colors.borders.light, flexGrow:1, marginLeft:6, paddingLeft:6, minWidth:75 }}>
                    <Text theme='h1' style={{ maxWidth:width * 0.55 }}>{bracket_competition.competition_name}</Text>
                    <Text theme='light' style={{ marginTop:3 }} color={Colors.text.action}>{}</Text>
                </View>
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{(bracket_competition.buy_in as number).toFixed(2)}</Text>
                    <Text theme='light'>Risk</Text>
                </View>
            </View>
        </View>
    )
}

export default BracketRow